
export default (account, discount) => {
  if(!account) {
    return Number(discount['grade_c'])
  }

  return Number(discount[account.type])
}